import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoggerService,
  RoutingService,
  tryNormalizeHttpError
} from '@spartacus/core';
import {
  OrganizationActions,
  OrgUnitActions
} from '@spartacus/organization/administration/core';
import { from, Observable } from 'rxjs';
import {
  catchError,
  map,
  switchMap,
} from 'rxjs/operators';
import * as UigB2BUserActions from './uig-b2b-user.action';
import { UigB2BUserConnector } from './uig-b2b-user.connector';

@Injectable()
export class UigB2BUserEffects {

  protected logger = inject(LoggerService);

  deleteB2BUser$: Observable<
    | UigB2BUserActions.DeleteB2BUserSuccess
    | UigB2BUserActions.DeleteB2BUserFail
    | OrgUnitActions.AssignApprover
    | OrganizationActions.OrganizationClearData
  > = createEffect(() => this.actions$.pipe(
    ofType(UigB2BUserActions.DELETE_B2B_USER),
    map((action: UigB2BUserActions.DeleteB2BUser) => action.payload),
    switchMap(({ userId }) => {
      return this.uigB2bUserConnector
        .delete(userId)
        .pipe(
          switchMap((_data) => {
            const successActions = [
              // TODO: change for 'payload: data' when backend API start to return user data on PATCH
              new UigB2BUserActions.DeleteB2BUserSuccess(userId),
            ] as any[];
            return successActions;
          }),
          catchError((error: HttpErrorResponse) =>
            from([
              new UigB2BUserActions.DeleteB2BUserFail({
                userId,
                error: tryNormalizeHttpError(error, this.logger),
              }),
              new OrganizationActions.OrganizationClearData(),
            ])
          )
        );
    })
  ));

  constructor(
    private actions$: Actions,
    private routingService: RoutingService,
    private uigB2bUserConnector: UigB2BUserConnector
  ) {}

  protected redirectToDetails(route, data) {
    if ((route as any)?.state?.context?.id !== '/organization/units') {
      this.routingService.go({
        cxRoute: 'orgUserDetails',
        params: data,
      });
    }
  }
}
